/**
 * The order api service
 */
import http from '@util/http';
import { xxcrm } from '../req';

/**
 * 订单列表
 */
export async function queryOrderList(params) {
  return http.get(xxcrm.ORDER_LIST, params);
}

/**
 * 获取订单详情
 */
export async function queryOrderInfo(uuid) {
  return http.get(xxcrm.ORDER_INFO, { uuid });
}

/**
 * 客户查询
 */
export async function queryCustom(params) {
  return http.get(xxcrm.CUSTOM_LIST, params);
}



// WEBPACK FOOTER //
// ./src/api/xxcrm/order.js